export const PlacementContentTypes = {
    NewsPolitics: 'newsPolitics',
    Games: 'games',
    MusicFilm: 'musicFilm',
    Sports: 'sports',
    Entertainment: 'entertainment',
    Dating: 'dating',
    AdviceInfo: 'adviceInfo',
    UgcLive: 'ugcLive',
    Utility: 'utility',
    Other: 'other',
} as const

export type PlacementContentType =
    (typeof PlacementContentTypes)[keyof typeof PlacementContentTypes]

export const PlacementRiskSignals = {
    Profanity: 'profanity',
    Explicit: 'explicit',
    Violence: 'violence',
    Hate: 'hate',
    Substances: 'substances',
    Gambling: 'gambling',
    Controversial: 'controversial',
    Misinfo: 'misinfo',
    LowQuality: 'lowQuality',
    MadeForKids: 'madeForKids',
} as const

export type PlacementRiskSignal = (typeof PlacementRiskSignals)[keyof typeof PlacementRiskSignals]

export const RisksEvaluationErrors = {
    UnknownError: 'UNKNOWN_ERROR',
    MetadataFailed: 'METADATA_FAILED',
} as const

export type RisksEvaluationError =
    (typeof RisksEvaluationErrors)[keyof typeof RisksEvaluationErrors]

export type RisksEvaluation = {
    contentType: PlacementContentType
    scores: Record<PlacementRiskSignal, number>
}
